<template>
  <div class="content">
    <table style="width: 100%">
      <tr>
        <td>Versicherungsnummer</td>
        <td>
          <SogDataLabel
            :value="data?.insuranceNumber"
          />

          <SogButton
            mdi-icon="mdi-shield"
            tooltip="Versicherung anzeigen"
            :button-style="SogButtonStyle.Link"
            @click="onInsuranceDetailsClicked"
          />
        </td>
      </tr>
      <tr /><tr>
        <td>Angefragt am</td>
        <td>
          <SogDataLabel
            :value="data?.cancelationRequestDate"
            value-type="DateTime"
          />
        </td>
      </tr>
      <tr>
        <td>Stornierungsdatum</td>
        <td>
          <SogDataLabel
            :value="data?.cancelationDate"
            value-type="DateTime"
          />
        </td>
      </tr>
      <tr>
        <td>Stornierungsstatus</td>
        <td>
          <SogDataLabel :value="data?.cancelationStatusDescription" />
        </td>
      </tr>
      <tr>
        <td>Kunde</td>
        <td>
          <SogDataLabel :value="data?.personName" />
        </td>
      </tr>

      <tr>
        <td>Prämie</td>
        <td>
          <SogDataLabel
            :value="data?.grossPrice"
            value-type="Money"
          />
        </td>
      </tr>
      <tr>
        <td>Versicherungsbetrag</td>
        <td>
          <SogDataLabel
            :value="data?.insuranceAmount"
            value-type="Money"
          />
        </td>
      </tr>
      <tr>
        <td>Stornierungsbetrag</td>
        <td>
          <SogDataLabel
            :value="data?.cancelationAmount"
            value-type="Money"
          />
        </td>
      </tr>
      <tr>
        <td>Angefragt von</td>
        <td>
          <SogDataLabel
            :value="data?.cancelationRequestByPersonName"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">


import InsuranceCancelation from "@/shared/model/InsuranceCancelation";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogButton from "@/shared/ui/SogButton.vue";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import {useNavigationStore} from "@/modules/Navigation/store";

interface Props {
  data?: InsuranceCancelation,
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
      data: undefined
    }
)
const _navigationStore = useNavigationStore()

function onInsuranceDetailsClicked() {
  _navigationStore.currentInsuranceId = props.data?.insuranceId
  _navigationStore.currentInsuranceNumber = props.data?.insuranceNumber
}

</script>


<style scoped>
.content {
  max-width: 400px;
}

td {
  padding-right: 5px;
}
</style>